"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Waveform = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Waveform = function Waveform() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M24 13.8235V15.0493C24 15.3878 23.7314 15.6622 23.4 15.6622H22.584C21.4217 15.6849 20.4105 14.8534 20.184 13.6887L18.252 3.61268C18.2125 3.5091 18.1148 3.44088 18.006 3.44088C17.8972 3.44088 17.7995 3.5091 17.76 3.61268L14.604 20.7737C14.3659 22.036 13.3024 22.9606 12.0445 22.9988C10.7866 23.037 9.67113 22.1786 9.36 20.9331L6.312 8.50358C6.2848 8.39017 6.18629 8.30966 6.072 8.30745H5.844C5.73742 8.30991 5.64274 8.37761 5.604 8.47906L3.816 13.9829C3.48998 14.9863 2.57098 15.6631 1.536 15.6622H0.6C0.268629 15.6622 0 15.3878 0 15.0493V13.8235C0 13.485 0.268629 13.2106 0.6 13.2106H1.536L3.336 7.70682C3.69337 6.60162 4.70457 5.85535 5.844 5.85588H6.072C7.28573 5.85757 8.34343 6.70071 8.64 7.90294L11.688 20.3692C11.7152 20.4826 11.8137 20.5631 11.928 20.5653C12.12 20.5653 12.216 20.4795 12.24 20.357L15.396 3.19592C15.6367 1.92111 16.729 1 18 1C19.271 1 20.3633 1.92111 20.604 3.19592L22.584 13.2106H23.4C23.7314 13.2106 24 13.485 24 13.8235Z"
  });
};

exports.Waveform = Waveform;